export default __webpack_public_path__ + "static/media/ref-kwp-krakow.1cf23140.pdf";